import { getAccessToken } from "../utils/storage";
import Axios from "../utils/http-request";

export const apiCreateComment = async (values: {
  post_id: number;
  comment: string;
}) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/${values.post_id}/comment`;

    const formData = JSON.stringify(values);
    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };
    // Send the POST request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);
    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiGetAllComments = async () => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/comments`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiGetAPostComments = async (post_id: number) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `posts/${post_id}/comments?page=1&page_size=10&comment_id=`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiGetAPostCommentReply = async (value: {
  post_id: number;
  comment_id: number;
}) => {
  
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `posts/${value.post_id}/comments?page=1&page_size=10&comment_id=${value.comment_id}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiGetReply = async (values: {
  post_id: number;
  comment_id: number;
}) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/${values.post_id}/comments?page=1&page_size=10&comment_id=${values.comment_id}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiLikeComments = async (comment_id: number) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/comments/${comment_id}/like`;
    const formData = new FormData();

    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };
    // Send the POST request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);
    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiPostReply = async (values: {
  post_id: number;
  comment: string;
  comment_id: number;
}) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/${values.post_id}/comment/${values.comment_id}`;

    const formData = JSON.stringify(values);
    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };
    // Send the POST request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);
    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};
